module.exports = __webpack_public_path__ + "assets/img/flag-de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flag-de.png
// module id = 56
// module chunks = 0